import React from "react";
import {
  FaInstagram,
  FaTelegramPlane,
  FaWhatsapp,
  FaLinkedinIn,
} from "react-icons/fa";
import Logo from "../../../assets/icons/logo-icon.png";

const socialLinks = [
  {
    title: "Instagram",
    subtitle: "آموزش و اخبار",
    href: "#",
    icon: FaInstagram,
    color: "#E1306C",
  },
  {
    title: "Telegram",
    subtitle: "اطلاع‌رسانی",
    href: "#",
    icon: FaTelegramPlane,
    color: "#2AABEE",
  },
  {
    title: "WhatsApp",
    subtitle: "ارتباط مستقیم",
    href: "#",
    icon: FaWhatsapp,
    color: "#25D366",
  },
  {
    title: "LinkedIn",
    subtitle: "شبکه حرفه‌ای",
    href: "#",
    icon: FaLinkedinIn,
    color: "#0A66C2",
  },
];

const SocialMedia = () => {
  return (
    <section
      className="relative overflow-hidden rounded-[34px] isolate
       
        "
    >
      {/* ================= BACKGROUND ================= */}
      <div
        className="absolute inset-0"
        style={{
          background: `
          radial-gradient(circle at 15% 20%, rgba(73,209,205,.12), transparent 35%),
          radial-gradient(circle at 85% 80%, rgba(176,14,177,.05), transparent 40%),
          linear-gradient(135deg,#083938 0%,#062C2C 55%,#031C1C 100%)
        `,
        }}
      />
      {/* Glow */}
      <div className="absolute -top-36 -left-36 w-[420px] h-[420px] 
      rounded-full bg-[#49D1CD]/5 blur-[120px]" />
      <div className="absolute -bottom-40 -right-32 w-[360px] 
      h-[360px] rounded-full bg-[#B00EB1]/5 blur-[120px]" />
      {/* Grid */}
      <div className="absolute inset-0 opacity-[0.03] 
      bg-[radial-gradient(circle_at_1px_1px,white_1px,transparent_0)] 
      bg-[length:30px_30px]" />
      {/* Border */}
      <div className="absolute inset-0 rounded-[34px] border border-white/5" />
      <div className="absolute inset-0 bg-gradient-to-b 
      from-white/[0.03] via-transparent to-transparent" />

      {/* ================= CONTENT ================= */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 py-8 lg:px-[60px] lg:py-12">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          {/* ===================================================== */}
          {/* TEXT */}
          {/* ===================================================== */}
          <div className="flex-1 text-center lg:text-right">
            <span
              className="
              inline-flex items-center gap-2 rounded-full border
              border-[#49D1CD]/10 bg-[#49D1CD]/5 backdrop-blur-xl
              px-4 py-2 text-xs font-semibold text-[#49D1CD]
            "
            >
              <span className="w-2 h-2 rounded-full bg-[#49D1CD] animate-pulse" />
              همراه ما باشید
            </span>

            <h2 className="mt-5 text-white font-black leading-tight 
               tracking-tight text-2xl md:text-3xl">
              همیشه <span className=" text-[#49D1CD]"> یک قدم </span>
              به سلامتی نزدیک‌تر
            </h2>

            <p
              className="mt-3 md:mt-4 max-w-xl mx-auto lg:mx-0 text-white/50 leading-6 md:leading-7 
            text-[14px] lg:text-[15px] font-light"
            >
              با دنبال کردن شبکه‌های اجتماعی، جدیدترین مقالات پزشکی، آموزش‌های
              تخصصی، نکات سلامت، معرفی پزشکان و خدمات جدید را سریع‌تر از همه
              دریافت کنید.
            </p>

            {/* Features (Removed Card Styling) */}
            <div className="mt-8 flex items-center justify-center 
            lg:justify-start gap-8 max-w-lg mx-auto lg:mx-0">
              <div className="text-center md:text-right">
                <h4 className="text-[#49D1CD] font-bold text-xl">+۵۰۰</h4>
                <p className="text-white/50 text-[13px] mt-1 font-light">
                  آموزش پزشکی
                </p>
              </div>

              {/* Divider */}
              <div className="w-px h-10 bg-white/10" />

              <div className="text-center md:text-right">
                <h4 className="text-[#49D1CD] font-bold text-xl">روزانه</h4>
                <p className="text-white/50 text-[13px] mt-1 font-light">
                  محتوای جدید
                </p>
              </div>
            </div>
          </div>

          {/* ===================================================== */}
          {/* GLASS CARD */}
          {/* ===================================================== */}
          <div className="relative w-full max-w-[380px] shrink-0">
            {/* Soft Background Glow */}
            <div className="absolute inset-0 scale-105 rounded-[30px]
             bg-[#49D1CD]/10 blur-[50px]" />

            {/* Main Card */}
            <div
              className="
              relative rounded-[30px] border border-white/5
              backdrop-blur-3xl overflow-hidden transition-all duration-500
              hover:-translate-y-1 hover:shadow-[0_15px_40px_-20px_rgba(73,209,205,.15)]
            "
              style={{
                background:
                  "linear-gradient(180deg,rgba(255,255,255,.04),rgba(255,255,255,.01))",
              }}
            >
              {/* Header */}
              <div className="relative px-6 pt-6 pb-4">
                <div className="absolute left-1/2 top-8 -translate-x-1/2 
                w-16 h-16 rounded-full bg-[#49D1CD]/10 blur-[30px]" />
                <div
                  className="
                  relative z-10 mx-auto w-16 h-16 rounded-[18px]
                  border border-white/5 bg-white/[0.03] backdrop-blur-2xl
                  flex items-center justify-center
                "
                >
                  <img
                    src={Logo}
                    alt="logo"
                    className="w-8 h-8 object-contain opacity-90"
                  />
                </div>
                <h3 className="mt-4 text-center text-white/90 font-medium text-base">
                  شبکه‌های اجتماعی
                </h3>
              </div>

              {/* ===================== */}
              {/* SOCIAL LINKS (Grid 2x2 - Horizontal Items) */}
              {/* ===================== */}
              <div className="px-4 md:px-5 pb-5 grid grid-cols-2 gap-3">
                {socialLinks.map((item, index) => {
                  const Icon = item.icon;
                  return (
                    <a
                      key={index}
                      href={item.href}
                      className="
                        group relative flex flex-row items-center 
                        justify-start text-right overflow-hidden rounded-[12px]
                        md:rounded-[18px] border border-white/5 bg-white/[0.02]
                        backdrop-blur-xl p-2 md:p-3 transition-all duration-500 
                        hover:border-[#49D1CD]/20 hover:bg-white/[0.04] gap-1.5 md:gap-2.5
                        hover:-translate-y-1 hover:shadow-[0_8px_20px_-10px_rgba(73,209,205,.2)]
                      "
                    >
                      {/* Hover Color Glow Background */}
                      <div
                        className="
                          absolute top-0 w-16 h-16 -translate-y-1/2
                          rounded-full blur-xl opacity-0 transition-all duration-500
                          group-hover:opacity-60 
                        "
                        style={{ background: item.color }}
                      />

                      {/* Icon */}
                      <div
                        className="
                          relative z-10 flex h-[28px] w-[28px] md:h-9 md:w-9 shrink-0 
                          items-center justify-center rounded-lg md:rounded-xl
                           border border-white/5 bg-white/[0.03] 
                          transition-all duration-500 group-hover:scale-110 group-hover:-rotate-3
                        "
                      >
                        <Icon
                          style={{ color: item.color }}
                          className="h-3 w-3 md:h-4 md:w-4 opacity-90 group-hover:opacity-100 "
                        />
                      </div>

                      {/* Text */}
                      <div className="relative z-10 flex flex-col items-start truncate">
                        <h4
                          className="text-white/90 font-medium text-[10.5px] md:text-[12px]
                         transition-all
                         duration-300 group-hover:text-[#49D1CD]"
                        >
                          {item.title}
                        </h4>
                        <p
                          className="mt-0.5 text-[8.5px] md:text-[9.5px] text-white/45 font-light 
                        transition-all duration-300 group-hover:text-white/60 truncate w-full"
                        >
                          {item.subtitle}
                        </p>
                      </div>

                      {/* Gentle overlay gradient on hover */}
                      <span
                        className="
                          absolute inset-0 rounded-[18px] opacity-0 transition-all
                          duration-700 group-hover:opacity-100
                        "
                        style={{
                          background:
                            "radial-gradient(circle at top, rgba(73,209,205,.05), transparent 70%)",
                        }}
                      />
                    </a>
                  );
                })}
              </div>

              {/* Footer */}
              <div className="border-t border-white/5 px-5 py-3">
                <div className="flex items-center justify-center gap-2">
                  <p className="text-[10px] font-light text-white/40">
                    همیشه در ارتباط باشیم
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;
